import { NgModule } from '@angular/core';
import { InputKeyboardNavigationDirective } from './input-keyboard-navigation.directive';

@NgModule({
    declarations: [InputKeyboardNavigationDirective],
    exports: [InputKeyboardNavigationDirective],
})
export class FiInputKeyboardNavigationModule {}
